/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/artikel-note/shop.artikel-note.component.ts.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {Artikel} from '../../../../models/artikel';
import {AppArticleNoteService} from '../../../../services/app.article-note.service';
import {BehaviorSubject} from 'rxjs';
import {ArtikelNote} from '../../../../models/artikel-note';
import {AppMessageService} from '../../../../services/app.message.service';
import {AppDialogsService} from '../../../../services/app.dialogs.service';

/**
 * Zweck: Beschreibt class ShopArtikelNoteComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // tslint:disable-next-line:component-selector
    selector: 'artikel-note',
    templateUrl: 'shop.artikel-note.component.html',
    styleUrls: ['shop.artikel-note.component.scss'],
    standalone: false
})
export class ShopArtikelNoteComponent implements OnChanges, OnInit {
  @Input() artikel: Artikel;

  note: ArtikelNote;

  edit_mode = new BehaviorSubject<boolean>(false);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public svc: AppArticleNoteService, private msg: AppMessageService, private dsvc: AppDialogsService,
              private cd: ChangeDetectorRef) {
  }

  private detectChanges() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    this.note = this.artikel.note;
    this.detectChanges();
  }


/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
    this.load();
    this.detectChanges();
  }

/**
 * Beschreibt Methode startedit und ihren Rückgabevertrag.
 */
  startedit($event) {
    $event.stopImmediatePropagation();
    $event.preventDefault();
    if (!this.note) {
      this.note = new ArtikelNote();
      this.note.artikelstamm = this.artikel.Artikelstamm;
      this.note.artnr = this.artikel.ArtikelNummer;
      this.note.note = '';
    }
    this.edit_mode.next(true);
  }

/**
 * Beschreibt Methode cancel und ihren Rückgabevertrag.
 */
  cancel($event) {
    $event.stopImmediatePropagation();
    $event.preventDefault();
    this.edit_mode.next(false);
  }

/**
 * Beschreibt Methode save und ihren Rückgabevertrag.
 */
  save($event) {
    $event.stopImmediatePropagation();
    $event.preventDefault();
    this.edit_mode.next(false);
    this.svc.setForArticle(this.artikel, this.note).subscribe(s => {
      if (s) {
        this.msg.info('Gespeichert!');
      } else {
        this.msg.error('Fehlgeschlagen!');
      }
      this.edit_mode.next(false);
    });
  }

/**
 * Beschreibt Methode delete und ihren Rückgabevertrag.
 */
  delete($event) {
    $event.stopImmediatePropagation();
    $event.preventDefault();
    this.dsvc.confirm(
      null,
      'Notiz löschen?',
      'Wollen Sie wirklich diese Notiz löschen?',
      () => {
        this.edit_mode.next(false);
        this.svc.deleteForArticle(this.artikel, this.note).subscribe(s => {
          if (s) {
            this.msg.info('Gelöscht!!');
            this.note = undefined;
          } else {
            this.msg.error('Fehlgeschlagen!');
          }
          this.edit_mode.next(false);
        });
      }
    );
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.load();
  }
}
